import { InjectionToken } from '@angular/core';

import type { IconName } from '@core/user-interface-legacy';

export type MissingFeature = {
  title: string;
  description?: string;
  link?: string;
  items?: Array<{
    title: string;
    link?: string;
  }>;
};

export type DowngradedFeatureItem = {
  title: string;
  icon: IconName;
  description: string;
  hideOnTrial?: boolean;
};

export interface DowngradeViewTextsI {
  header: string;
  headerTrial: string;
  heading: string;
  headingTrial: string;
  subheading: string;
  subheadingTrial: string;
  accordionHeading: string;
  trialConfirmCheckbox: string;
  features: MissingFeature[];
  downgradedFeaturesLeft: DowngradedFeatureItem[];
  downgradedFeaturesRight: DowngradedFeatureItem[];
}

export const DowngradeTextsToken = new InjectionToken<DowngradeViewTextsI>('DowngradeViewTexts');
